import React from "react";
import { MDBContainer, MDBBtn } from 'mdb-react-ui-kit';
import "../../assets/styles/UpcomingShows.css";

export default function UpcomingShows () {
        return (
          <MDBContainer id="shows" className="upcoming-shows-container" fluid>
            <div className="upcoming-shows-header">
              UPCOMING SHOWS
            </div>
            <div>
              <div className="upcoming-shows-event row">
                <div className="upcoming-shows-event-date col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    AUGUST 25th
                </div>
                <div className="upcoming-shows-event-location col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div>
                        TBA
                    </div>
                    <div>
                        WINDSOR, ON
                    </div>
                </div>
                <div className="upcoming-shows-event-info col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <MDBBtn outline color='light' target="_blank" href="https://www.instagram.com/tirothetyrant/?hl=en">
                    More Info
                </MDBBtn>
                </div>
              </div>
              <div className="upcoming-shows-event row">
                <div className="upcoming-shows-event-date col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    SEPTEMBER 1st
                </div>
                <div className="upcoming-shows-event-location col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div>
                        TBA
                    </div>
                    <div>
                      WINDSOR, ON
                    </div>
                </div>
                <div className="upcoming-shows-event-info col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <MDBBtn outline color='light' target="_blank" href="https://www.instagram.com/tirothetyrant/?hl=en">
                    More Info
                </MDBBtn>
                </div>
              </div>
            </div>
            </MDBContainer>);

}